// src/components/AdminNotifications.js

import React from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { Box, Badge, Spinner, Alert, AlertIcon, List, ListItem } from '@chakra-ui/react';
import Api from '../../api/ApiUrl'

const fetchUnseenBookings = async () => {
  const { data } = await axios.get(`${Api}/api/v1/payfiles/bookings`, {
    params: { seenByadmin: false },
  });
  return data;
};
const AdminNotifications = () => {
  const { data, isLoading, isError, error } = useQuery('unseenBookings', fetchUnseenBookings);
  console.log(data)

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <Alert status="error">
        <AlertIcon />
        {error.message}
      </Alert>
    );
  }

  return (
    <Box>
      <Badge colorScheme="red" fontSize="lg">
        Unseen Bookings: {data?.data?.data?.length}
      </Badge>
      <List mt="4">
        {data?.data?.data?.map((booking,i) => (
          <ListItem key={booking?._id}>
          {i+1} : {booking?.userId?.name} booked {booking?.item?.name} for {booking?.amount}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default AdminNotifications;
